'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, version_id) {
  return function (dispatch) {
    console.log('in iso open');
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      version_id: version_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/open',
        method: 'POST',
        data: {
          version_id: version_id
        }
      },
      types: ['OPEN_EVENT_START', 'OPEN_EVENT', 'OPEN_EVENT_ERROR']
    })).then(function (res) {
      if (res.type === 'OPEN_EVENT_ERROR') {
        return Promise.reject(res);
      }
    }).catch(function (e) {
      return Promise.reject(e);
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/openEvent.js
// module id = 645
// module chunks = 0